import React, { useEffect, useState } from 'react';
import Input from '../shared/Input';

const imageArray = [{
    id: 1, url: 'https://res.cloudinary.com/dm80mcqzl/image/upload/v1748601559/Group_2_jnkfqu.png',
},
{
    id: 2,
    url: 'https://res.cloudinary.com/dm80mcqzl/image/upload/v1748619123/Group_2_jnkfqu.png',
},
{
    id: 3,
    url: 'https://res.cloudinary.com/dm80mcqzl/image/upload/v1748619188/Group_2_jnkfqu.png',
},
];

const Home = () => {
    const [fadeOut, setFadeOut] = useState(false);
    const [currentImage, setCurrentImage] = useState(0);
    console.log('cherckImage', currentImage)

    const firstLine = ['Something', 'Big', 'Is', 'Coming'];
    const secondLine = ['to', 'the', 'World', 'of', 'Sport'];

    useEffect(() => {
        const fadeTimer = setTimeout(() => {
            setFadeOut(true);
        }, 2000); // Let paragraph show for 6s before fading

        const imageTimer = setInterval(() => {
            setCurrentImage((prev) => (prev + 1) % imageArray.length);
        }, 2000); // Rotate image every 5s

        console.log("chgeckImageTImer", imageTimer)

        return () => {
            clearTimeout(fadeTimer);
            clearInterval(imageTimer);
        };
    }, [currentImage, imageArray.length]);

    return (
        <div className="relative lg:min-h-screen 2xl:min-h-screen min-h-auto h-[810px] lg:h-auto 2xl:h-auto bg-[#0E0E0E] text-white pt-[3rem] overflow-x-hidden lg:overflow-y-hidden 2xl:overflow-y-hidden overflow-y-auto flex flex-col justify-between">


            <div className="absolute inset-0 overflow-hidden z-10">
                <div
                    className="absolute w-[520px] h-[520px] rounded-full opacity-12"
                    style={{
                        background:
                            'radial-gradient(circle, #16A0AA80 50%, #02020200 -30%, rgba(0, 217, 255, 0.15) 5%, transparent 20%)',
                        filter: 'blur(42px)',
                        animation: 'moveCircle6 20s ease-in-out infinite',
                    }}
                />
            </div>

            {/* Foreground Content */}
            <div className="relative z-10 flex flex-col flex-col-reverse lg:flex-row items-center justify-around w-full px-4 animate-fade-in delay-[1000ms]">

                {/* Left Side */}
                <div className="max-w-xl w-full pb-10 lg:pb-0">
                    {/* Animated Heading */}
                    <h1 className="lg:text-[48px] text-[32px] font-bold mb-6 animate-fade-in delay-[1200ms] px-4 lg:px-0 2xl:px-0">
                        {/* <div className="flex flex-wrap gap-x-2 mb-1">
                            {firstLine.map((word, index) => (
                                <span
                                    key={index}
                                    className="inline-block opacity-0 animate-fade-in"
                                    style={{ animationDelay: `${index * 0.4}s` }}
                                >
                                    {word}
                                </span>
                            ))}
                        </div>
                        <div className="flex flex-wrap gap-x-2">
                            {secondLine.map((word, index) => (
                                <span
                                    key={index}
                                    className="inline-block opacity-0 animate-fade-in"
                                    style={{ animationDelay: `${(firstLine.length + index) * 0.4}s` }}
                                >
                                    {word}
                                </span>
                            ))}
                        </div> */}
                        Something Big Is Coming to the World of Sport.
                    </h1>

                    <p className="text-lg font-semibold mb-2 animate-fade-in delay-[1400ms] px-4 lg:px-0 2xl:px-0">
                        Want to stay in the loop?
                    </p>
                    {/* <div className="flex flex-wrap text-lg font-semibold mb-2">
                        {['Want', 'to', 'stay', 'in', 'the', 'loop?'].map((word, index) => (
                            <span
                                key={index}
                                className="inline-block opacity-0 animate-fade-in mr-2"
                                style={{ animationDelay: `${(firstLine.length + secondLine.length + index) * 0.4}s` }}
                            >
                                {word}
                            </span>
                        ))}
                    </div> */}

                    {/* Fade-out paragraph */}
                    <p
                        className={`text-gray-400 mb-6 animate-fade-in delay-[2000ms] px-4 lg:px-0 2xl:px-0`}
                    >
                        We’re building something for athletes, coaches, and fans who are ready for what’s next. Join the waitlist now!
                    </p>

                    <Input />

                    <p className="text-xs text-gray-500 animate-fade-in delay-[2500ms] px-4 lg:px-0 2xl:px-0">
                        (Stay tuned! We’ll drop you a note when we’re live!)
                    </p>

                </div>

                {/* Image Rotator (NO float) */}
                <div className="flex  items-start transition-opacity duration-700 ease-in-out">
                    <img
                        src={imageArray[currentImage]?.url}
                        className="object-cover lg:w-[421px] lg:h-[564px] w-[195px] h-[261px]"
                        alt={`Athlete ${currentImage + 1}`}
                        key={currentImage}
                    />
                </div>
            </div>
            {/* Footer */}
            <div className="relative z-10 flex lg:flex-row 2xl:flex-row flex-col  items-center justify-around w-full px-4 pb-10">
                <p className="text-[14px] font-[400] text-[#A7A7A7] mt-4 lg:mt-0 lg:ml-[-12rem] ml-0 px-4 lg:px-0 2xl:px-0">
                    ❤️ Built in Canada, for sports communities worldwide.
                </p>
                <p className="font-[600] text-[14px] text-[#333333] mt-4 lg:mt-0">@2025 Sporthub</p>
            </div>
        </div>
    );
};

export default Home;
